<template>
  <div>
    <div class="one-left d-xl-flex" style="margin-bottom: 10px;justify-content: space-between;">
      <div class="ms-3 d-flex align-items-center">
        <div class="showing-div-black" v-if="applicantsCount.total != 0">
          <template v-if="applicantsCount.total === 1">
            1名表示 / 1名 登録
          </template>
          <template v-else>
            {{ applicantsCount.from }}-{{ applicantsCount.to }}名表示 / {{ applicantsCount.total }}名 登録
          </template>
        </div>
        <div
          class="d-flex align-items-start"
          style="margin-top: 8px; margin-left: 140px;"
          v-if="lists.length >= 1"
        >
          <label class="review-list-picker-label me-2 mb-0">表示するリスト</label>
          <div class="review-list-picker" ref="reviewListPicker">
            <div class="review-list-picker-summary" @click="pickerOpen = !pickerOpen">
              <span class="review-list-picker-title">{{ summaryTitle }}</span>
              <span
                v-if="summaryCount"
                class="review-list-picker-badge"
                >{{ summaryCount }}</span>
              <span class="review-list-picker-arrow">∨</span>
            </div>
            <div class="review-list-picker-rows" v-if="pickerOpen">
              <div
                v-for="list in visibleLists"
                :key="list._id"
                class="review-list-picker-row"
                :class="{ 'review-list-picker-row--selected': isSelected(list._id) }"
                @click="selectList(list._id)"
              >
                <span class="review-list-picker-row-title">{{ list.title }}</span>
                <span v-if="list.count" class="review-list-picker-badge">{{ list.count }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- No list permission at all — no dropdown to pick from, but the field itself
             still shows per the spec's empty-state mock. -->
        <div class="ms-4 d-flex align-items-start" v-else-if="lists.length === 0">
          <label class="review-list-picker-label me-2 mb-0">表示するリスト</label>
          <div class="review-list-picker review-list-picker--empty"></div>
        </div>
      </div>
      <div class="one-right" style="margin-left: 60px;">
        <ul class="nostyle ul-button d-flex justify-content-center">
          <li>
            <div
              class="favorite-wrapper favorite-border"
              @click="toggleFavoriteApplicants"
            >
              <Favorite :favorite="favoritesOnly" :fromSearchBar="true" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- Bulk-operation UI hidden here (unstable) — remove `v-if="false"` to restore. -->
    <div class="ms-3" style="margin-bottom: 20px;" v-if="false && !isEmpty">
      <b-dropdown
        id="bulkActionDropdown"
        ref="bulkActionDropdown"
        :text="bulkActionLabel"
        class="btn-sm-drop dd-button"
        variant="secondary"
        :disabled="jobseekerIds.length === 0"
        :class="{ 'active-bulk-btn': jobseekerIds.length > 0 }"
        @hidden="resetBulkAction"
      >
        <li class="bulk-menu-item position-relative">
          <a href="#" class="dropdown-item d-flex justify-content-between align-items-center">
            ステータス一括更新
          </a>
          <div class="bulk-submenu" @click.stop>
            <div class="status-list p-2">
              <div
                v-for="(status, index) in client_status_list"
                :key="index"
                class="form-check mb-2"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  :id="'under-review-bulk-status-' + index"
                  :value="status"
                  v-model="selectedBulkStatus"
                />
                <label
                  class="form-check-label ms-1"
                  :for="'under-review-bulk-status-' + index"
                  style="white-space: nowrap; cursor: pointer;"
                >
                  {{ status }}
                </label>
              </div>
            </div>
            <div class="text-center p-2 border-top">
              <button
                class="btn btn-primary btn-sm btn-block bulk-operation-btn"
                @click="applyBulkStatus"
                >OK</button>
            </div>
          </div>
        </li>
        <b-dropdown-item v-if="isReviewer" @click="showReviewListModal = true">
          リストに振分け
        </b-dropdown-item>
        <b-dropdown-item @click="openBulkMemoModal">
          メモ一括入力
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <b-modal
      ref="bulkMemoModal"
      title="メモ一括入力"
      @ok.prevent="saveBulkMemo"
      cancel-title="キャンセル"
      ok-title="保存"
      :ok-disabled="loading"
    >
      <div class="d-block text-center">
        <b-form-textarea
          v-model="bulkMemoText"
          trim
          :rows="15"
          :max-rows="15"
        ></b-form-textarea>
      </div>
    </b-modal>

    <ReviewListPopup
      ref="reviewListPopup"
      :showReviewListModal="showReviewListModal"
      :isBulkOperation="true"
      :jobseekerIds="jobseekerIds"
      @hideModal="hideReviewList"
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import Favorite from '@/components/dashboard/applicants/Favorite.vue';
import mutations from '@/config/mutations';
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import ReviewListPopup from '../ReviewListPopup.vue';

export default {
  name: 'UnderReviewSearchBar',
  components: {
    Favorite,
    ReviewListPopup,
  },
  data() {
    return {
      pickerOpen: false,
      bulkMemoText: '',
      showReviewListModal: false,
      selectedBulkStatus: null,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      applicantsCount: ({ applicant }) => applicant.applicantsCount,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      client_status_list: ({ applicant }) => applicant.client_status,
      applicantsLoading: ({ applicant }) => applicant.loading,
    }),
    ...mapGetters({
      underReviewSummary: 'getUnderReviewSummary',
      selectedReviewListIds: 'getSelectedReviewListIds',
      isReviewer: 'isCreateReviewUser',
    }),
    bulkActionLabel() {
      return '一括操作 ▼';
    },
    isEmpty() {
      // While the first fetch is still in flight, applicantsCount.total is undefined —
      // treat that as "don't know yet", not "empty", so the button doesn't flash visible
      // before flipping to hidden once the real (possibly-zero) count arrives.
      return !this.applicantsLoading && this.applicantsCount.total === 0;
    },
    lists() {
      return this.underReviewSummary.lists || [];
    },
    visibleLists() {
      // Lists with 0 確認中 registrants stay selectable (badge just hides its
      // count in the template) — only the currently-summarized list is excluded.
      return this.lists.filter(l => l._id !== this.summaryListId);
    },
    summaryListId() {
      if (this.isAllSelected) return this.lists.length ? this.lists[0]._id : null;
      return this.localSelectedIds[0] || null;
    },
    localSelectedIds: {
      get() {
        return this.selectedReviewListIds;
      },
      set(value) {
        this.setSelectedReviewListIds(value);
      },
    },
    isAllSelected() {
      return !this.localSelectedIds.length || this.localSelectedIds.length === this.lists.length;
    },
    summaryTitle() {
      if (!this.summaryListId) return 'すべてのリスト';
      const selected = this.lists.find(l => l._id === this.summaryListId);
      return selected ? selected.title : '';
    },
    summaryCount() {
      // Mirror summaryTitle exactly — both describe the same "currently shown" list via
      // summaryListId. A separate isAllSelected branch here previously returned the grand
      // total while the title showed one specific list's name — a real mismatch.
      const selected = this.lists.find(l => l._id === this.summaryListId);
      return selected ? selected.count : null;
    },
  },
  methods: {
    ...mapMutations([
      mutations.applicant.TOGGLE_FAVORITES,
      'mutateApplicantsAfterMultipleStatus',
      'setReloadApplicants',
      'setJobseekerIds',
      'setCheckAll',
      'setSelectedReviewListIds',
    ]),
    toggleFavoriteApplicants() {
      this[mutations.applicant.TOGGLE_FAVORITES](!this.favoritesOnly);
    },
    isSelected(listId) {
      // isAllSelected is the default "nothing explicitly chosen" state — don't highlight
      // every row for it, only rows the user actually picked.
      if (this.isAllSelected) return false;
      return this.localSelectedIds.includes(listId);
    },
    selectList(listId) {
      this.localSelectedIds = [listId];
      this.pickerOpen = false;
    },
    closePicker(event) {
      const el = this.$refs.reviewListPicker;
      if (el && !el.contains(event.target)) this.pickerOpen = false;
    },
    resetBulkAction() {
      this.selectedBulkStatus = null;
    },
    closeBulkActionDropdown() {
      const dropdown = this.$refs.bulkActionDropdown;
      if (dropdown && typeof dropdown.hide === 'function') {
        dropdown.hide();
      }
    },
    applyBulkStatus() {
      if (this.selectedBulkStatus) {
        this.changeStatus(this.selectedBulkStatus);
      }
    },
    changeStatus(status) {
      if (this.jobseekerIds.length === 0) return;
      this.loading = true;
      ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
        jobseekerIDs: this.jobseekerIds,
        status,
        isNewPanel: true,
      })
        .then(({ data }) => {
          this.mutateApplicantsAfterMultipleStatus(data.data);
          this.setReloadApplicants(true);
          this.closeBulkActionDropdown();
        })
        .catch(({ response }) => {
          console.log(response);
          this.loading = false;
        })
        .then(() => {
          this.setJobseekerIds([]);
          this.setCheckAll(false);
          this.resetBulkAction();
        });
    },
    openBulkMemoModal() {
      this.bulkMemoText = '';
      this.$refs.bulkMemoModal.show();
    },
    saveBulkMemo() {
      if (this.loading || this.jobseekerIds.length === 0 || !this.bulkMemoText.trim()) return;
      this.loading = true;
      ApiService.put(Api.endpoints.MULTIPLE_MEMO, {
        jobseekerIds: this.jobseekerIds,
        memo: this.bulkMemoText,
      })
        .then(() => {
          this.setReloadApplicants(true);
          this.bulkMemoText = '';
          this.$refs.bulkMemoModal.hide();
          this.setCheckAll(false);
          this.setJobseekerIds([]);
          this.resetBulkAction();
        })
        .catch(({ response }) => {
          console.error(response);
        })
        .then(() => {
          this.loading = false;
        });
    },
    hideReviewList() {
      this.showReviewListModal = false;
    },
  },
  mounted() {
    document.addEventListener('click', this.closePicker);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closePicker);
  },
};
</script>

<style scoped>
.active-bulk-btn::v-deep .btn-secondary {
    background-color: #5d7593 !important;
    color: white !important;
    border-color: #5d7593 !important;
}

.showing-div-black {
    color: #000000 !important;
    font-weight: bold;
    white-space: nowrap;
}

.review-list-picker-label {
    font-size: 14px;
    font-weight: bold;
    color: #3c3c3c;
    white-space: nowrap;
    width: 106px;
    flex-shrink: 0;
}

.review-list-picker {
    position: relative;
    width: 460px;
}

.review-list-picker--empty {
    height: 30px;
    border: 1px solid #c6c6c6;
    background-color: #fff;
}

.review-list-picker-summary {
    display: flex;
    align-items: center;
    height: 30px;
    padding: 0 10px;
    border: 1px solid #c6c6c6;
    background-color: #fff;
    cursor: pointer;
    font-size: 14px;
    color: #3c3c3c;
}

.review-list-picker-title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.review-list-picker-badge {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 4px;
    margin-left: 8px;
    border-radius: 999px;
    background-color: #006c6b;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
}

.review-list-picker-arrow {
    flex-shrink: 0;
    margin-left: 8px;
    color: #3c3c3c;
}

.review-list-picker-rows {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #fff;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1051;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.review-list-picker-row {
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    border: 1px solid #c6c6c6;
    border-top: none;
    font-size: 14px;
    color: #3c3c3c;
    cursor: pointer;
}

.review-list-picker-row-title {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.review-list-picker-row:hover {
    background-color: #f0f5f7;
}

.review-list-picker-row--selected {
    background-color: #e7f6f6;
    font-weight: bold;
}

.one-right .btn-heart:hover i {
  color: #aba2a2;
}

.bulk-operation-btn {
  border-color: rgb(98, 164, 253);
  background: rgb(98, 164, 253);
  min-width: 60px !important;
  width: 20px;
  margin: auto;
}

.bulk-menu-item:hover .bulk-submenu {
  display: block;
}

.bulk-submenu {
  display: none;
  position: absolute;
  top: -8px;
  left: 100%;
  width: 280px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1050;
}

.form-check-input {
  margin-top: 0.3rem;
}

::v-deep .dropdown-menu {
  overflow: visible !important;
}
</style>
